// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2DmdE","box":"WorkspacesBox_box__e4oJF","node":"WorkspacesBox_node__V7aVD"};